import { IAppState } from '@myStore/app.state';
import { ICoursesViewState } from '@myStore/courses-view/courses-view.state';
import { createSelector } from '@ngrx/store';

const coursesViewSelector = (state: IAppState) => state.coursesView;

export const selectCourseDetailLoading = createSelector(
  coursesViewSelector,
  (state: ICoursesViewState) => state?.detail.isLoading
);

export const selectCourseDetail = createSelector(
  coursesViewSelector,
  (state: ICoursesViewState) => state?.detail.data
);

export const selectLoadingCoursesList = createSelector(
  coursesViewSelector,
  (state: ICoursesViewState) => state?.isLoading
);

export const selectCoursesList = createSelector(
  coursesViewSelector,
  (state: ICoursesViewState) => state?.list?.courses
);

export const selectTotalStudents = createSelector(
  coursesViewSelector,
  (state: ICoursesViewState) => state?.list?.active_students_total
);

export const selectCurrentCourseId = createSelector(
  coursesViewSelector,
  (state: ICoursesViewState) => state?.currentCourseId
);
